import React from 'react';
import PropTypes from 'prop-types';
import { MultiSelectDropdown } from './MultiSelectDropdown';

import { connect } from 'react-redux';
import { translator } from 'mage-i18n';
import { SpacerVertical } from '@klarna/bubble-ui';
import { ValueList } from './ValueList';

type ArrayFieldProps = {
  clearLabel: string;
  disabled?: boolean;
  label: string;
  max: number;
  min: number;
  options: { key: string; label: string }[];
  selectedLabel: string;
  t: any;
  onChange: (value: string[]) => void;
  value: string[];
};

export const ArrayFieldComponent = ({
  clearLabel,
  disabled = false,
  label,
  max = Number.MAX_SAFE_INTEGER,
  _min = 0,
  options = [],
  selectedLabel,
  t,
  onChange = () => {},
  value = [],
  ...props
}: ArrayFieldProps & Partial<any>): JSX.Element => {
  const toggleValue = key =>
    onChange(value.includes(key) ? value.filter(k => k !== key) : [...value, key]);

  return (
    <>
      <MultiSelectDropdown
        {...props}
        fieldTooltip={
          value.length >= max ? t('products-fe.error_messages.validation.max', { max }) : undefined
        }
        disabled={disabled || value.length >= max}
        label={label}
        max={max}
        options={options}
        addValue={toggleValue}
        value={value}
      />
      {value.length > 0 && <SpacerVertical spaceToken="space/300" />}
      <ValueList
        clearLabel={clearLabel || t('products-fe.general.clear_all')}
        label={selectedLabel || `${t('products-fe.general.selected')}:`}
        onChange={onChange}
        options={options}
        value={value}
      />
    </>
  );
};

ArrayFieldComponent.propTypes = {
  label: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  clearLabel: PropTypes.object,
  disabled: PropTypes.bool,
  max: PropTypes.number,
  min: PropTypes.number,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
  selectedLabel: PropTypes.string,
  value: PropTypes.array,
  onChange: PropTypes.func,
};

export const ArrayField = connect(state => ({ t: translator(state) }))(ArrayFieldComponent);
